import React, { useEffect, useState, useContext } from "react";
import { useHistory, generatePath } from 'react-router-dom'
import { alpha, makeStyles, AppBar, Button, Grid, TextField, Typography, Hidden, InputAdornment, IconButton, Toolbar, Box, Paper, Divider, Tooltip } from "@material-ui/core";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from '@material-ui/icons/Add';
import DraftsIcon from '../../../images/draft.svg';
import Publish from '../../../images/published.svg';
import AppConstants from "../../../common/AppConstants";
import { CurriculumMasterData, CurriculumDataService } from '../../../services/index'
import { AppDataContext } from '../../../common/AppContext'
import RouteConstants from "../../../common/RouteConstants";
import PageNotFoundUI from "../../../sharedComponents/emptyStateUIContainers/PageNotFoundUI";

import CurriculumCard from "./CurriculumCard";
import SectionLoader from "../../../sharedComponents/Loader/SectionLoader";
import Pagination from "../../../sharedComponents/Pagination/Pagination";

const curriculumList = [
    {
        id: "1",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Starter",
        badge: "gold",
        assignedprospects: "17",
        curriculumStatus: 0
    },
    {
        id: "2",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Intermediate",
        badge: "bronze",
        assignedprospects: "20",
        curriculumStatus: 1
    },
    {
        id: "3",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Expert",
        badge: "platinum",
        assignedprospects: "05",
        curriculumStatus: 0
    },
    {
        id: "4",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Starter",
        badge: "gold",
        assignedprospects: "0",
        curriculumStatus: 0
    },
    {
        id: "5",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Expert",
        badge: "gold",
        assignedprospects: "13",
        curriculumStatus: 0
    },
    {
        id: "6",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Starter",
        badge: "platinum",
        assignedprospects: "15",
        curriculumStatus: 0
    },
    {
        id: "7",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Expert",
        badge: "bronze",
        assignedprospects: "03",
        curriculumStatus: 0
    },
    {
        id: "8",
        title: "Basketball for Beginner 1",
        assignedby: 'John Doe',
        date: "July 12, 2024",
        curriculumlevel: "Starter",
        badge: "bronze",
        assignedprospects: "07",
        curriculumStatus: 0
    },
]

const useStyles = makeStyles((theme) => ({
    subHeader: {
        background: '#fff',
    },
    subHeaderTitle: {
        fontWeight: '600',
        flex: '1',
    },
    titleHeader: {
        fontWeight: '600',
    },
    cardbox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        border: '1px solid #b3b3b3',
        boxShadow: '0px 0px 1px 0px #b3b3b3',
        '& .MuiCardHeader-root': {
            padding: theme.spacing(.5, 2, 0),
            '& .MuiCardHeader-action': {
                marginTop: '0',
                marginRight: '0',
            },
        },
        '& .MuiCardContent-root': {
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(.75) + "px !important",
            // height: '100%',
        },
        '& .MuiCardActions-root': {
            justifyContent: 'flex-end',
            '& .MuiButton-root': {
                background: '#000',
                color: '#fff',
                textTransform: 'unset',
                borderRadius: '50px',
                '& .MuiButton-label': {
                    '& .MuiSvgIcon-root': {
                        color: '#fff',
                    },
                },
            },
        },
    },
    cardFooterText: {
        fontSize: '0.65rem',
        lineHeight: '1',
        fontWeight: '500',
    },
    starterColor: {
        color: '#2c8416',
    },
    intermediateColor: {
        color: '#ff7e06',
    },
    expertColor: {
        color: '#c91020',
    },
    iconFontSize: {
        fontSize: '1rem',
    },
    Pagination: {
        '& > div': {
            marginLeft: theme.spacing(1),
            [theme.breakpoints.down("xs")]: {
                marginLeft: theme.spacing(0),
            },
            '& > svg': {
                color: '#ffffff',
            },
            '& > div': {
                backgroundColor: '#1d428a !important',
                borderRadius: '4px !important',
                color: '#ffffff',
            },
        },
    },
}));

const CurriculumListContainer = () => {
    const history = useHistory()
    const classes = useStyles();
    const locationState = history.location.state;
    const [filter, setFilter] = useState(() => {
        const defaults = {
            curriculumBadge: [0],
            curriculumLevel: [0],
            curriculumStatus: [-1],
            curriculumAccess: [],
            status: [1],
            pageIndex: 1,
            recordCount: 0,
            pageSize: 12
        };
        return locationState ? { ...defaults, ...locationState } : defaults;
    })
    const [loading, setLoading] = useState(true)
    const [filterText, setFilterText] = useState('')
    const [filterCurriculum, setFilterCurriculum] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0)

    const handleInputChange = (name, value) => {
        let filterData = { ...filter }
        if (name == 'curriculumLevel') {
            value = [value]
        }

        filterData["curriculumStatus"] = AppConstants.CURRICULUM_STATUS_PUBLISH.id;
        filterData[name] = value
        filterData["pageIndex"] = 1;
        setFilter(filterData)
    };

    useEffect(() => {
        getCurriculumData()
    }, [filter])

    const getCurriculumData = () => {
        setLoading(true);
        let _payload = {
           // curriculumBadge: filter.curriculumBadge,
           // curriculumLevel: filter.curriculumLevel,
           // curriculumStatus: filter.curriculumStatus,
            filterText: filterText,
            pageIndex: filter.pageIndex,
            pageSize: filter.pageSize,

        }
        CurriculumDataService.getMyCurriculums(_payload)
            .then(res => {
                //console.log(res);
                setFilterCurriculum(res.data)
                setTotalRecords(res.totalRecordCount)
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                setLoading(false)
            })
    }


    const handleCurriculumStart = (curriculumID) => {
        setLoading(true);
        console.log("Curriculum started " + curriculumID); 
        history.push(generatePath(RouteConstants.CURRICULUM_CONTENT, { id: curriculumID }))
        setLoading(false);
    }

    const handleBadgeChecked = (value, isChecked) => {
        let newFilter = { ...filter }
        if (value != 0) {
            let zeroIndex = newFilter.curriculumBadge.indexOf(0)
            if (zeroIndex > -1) {
                newFilter.curriculumBadge.splice(zeroIndex, 1)
            }
            if (isChecked) {
                newFilter.curriculumBadge.push(value)
            } else {
                let i = newFilter.curriculumBadge.indexOf(value)
                newFilter.curriculumBadge.splice(i, 1)
            }
        } else {
            newFilter.curriculumBadge = [0]
        }
        newFilter.pageIndex = 1;

        setFilter(newFilter)
    }

    const handlePageSizeChange = (size) => {
        setFilterCurriculum([]);
        setFilter({ ...filter, pageSize: size, pageIndex: 1, recordCount: 0 })
    }

    const onPageNoChange = (pageNo) => {
        setFilterCurriculum([]);
        setFilter( { ...filter, pageIndex : pageNo})
    }

    const handleOnKeyUp = (event) => {
        if (event.keyCode === 13) {
            handleSearch();
        }
    }
    const handleSearch = () =>{
        setFilter( { ...filter, pageIndex : 1})
    }

    const handleClearText = () => {
        setFilterText('');
        handleSearch();
    }

    return (
        <>
            <AppBar position="static" className={classes.subHeader}>
                <Toolbar variant="dense">
                    <Typography variant="body2" className={classes.subHeaderTitle} color="secondary">
                        List of Curriculums
                    </Typography>
                    <Box style={{ flexGrow: 1 }} />
                </Toolbar>
            </AppBar>
            <Box style={{ padding: '16px' }}>
                <Paper>
                    <Box component="div" display="flex" alignItems="center" paddingX={2} paddingY={1}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item xs={2} sm={2} md={2}>
                                <Typography variant="body2" color="primary" className={classes.titleHeader}>{`Total Curriculums: ${totalRecords}`}</Typography>
                            </Grid>                           
                            <Grid item xs={2} sm={2} md={2}>
                                <div className={classes.search}>
                                    <TextField size="small"
                                        fullWidth
                                        value={filterText}
                                        onKeyUp={(event) => handleOnKeyUp(event)}
                                        onChange={e =>setFilterText(e.target.value)}
                                        variant="outlined"
                                        id="search"
                                        placeholder="Search…"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {filterText != "" && (
                                                        <>
                                                            <ClearIcon
                                                                fontSize="small"
                                                                onClick={handleClearText}
                                                                style={{ cursor: "pointer" }}
                                                            ></ClearIcon>
                                                            <SearchIcon 
                                                            onClick={e => handleSearch()}                                                                
                                                                style={{ cursor: "pointer" }}
                                                                size="small"
                                                            ></SearchIcon>
                                                        </>
                                                    )}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider style={{ width: '100%' }} />
                    <Box component="div" display="flex" alignItems="center" padding={2} style={{ display: 'flex', alignItems: 'center', padding: '12px', }}>
                        {loading ? <SectionLoader /> :
                            <Grid container alignItems="center" spacing={2}>
                                {filterCurriculum && filterCurriculum.length > 0 ? <>
                                    {filterCurriculum.length > 0 && filterCurriculum.map((option, i) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={i}>
                                            { 
                                                option && option.curriculumStatus == 1 && <CurriculumCard option={option} handleCurriculumStart={handleCurriculumStart} key={option.curriculumID} />
                                            }
                                        </Grid>
                                    ))}

                                    {filterCurriculum && filterCurriculum.length > 0 &&
                                        <Grid item xs={12} sm={12} md={12}>
                                            <Box display="flex" alignItems="center" justifyContent="center">
                                                <Hidden xsDown>
                                                    <label>Page Size</label>
                                                </Hidden>
                                                <TextField
                                                    id="outlined-select-currency"
                                                    select
                                                    value={String(filter.pageSize)}
                                                    onChange={(event) => handlePageSizeChange(parseInt(event.target.value))}
                                                    variant="outlined"
                                                    size="small"
                                                    className={classes.Pagination}
                                                >
                                                    {AppConstants.PAGE_SIZES.map((option) => (
                                                        <MenuItem key={option} value={option} className="MenuItem">
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                                <Pagination
                                                    pageSize={filter.pageSize}
                                                    totalProfile={totalRecords}
                                                    changePageNumber={(e) => {
                                                        onPageNoChange(e.selected + 1);
                                                    }}
                                                    currentPageNo={filter.pageIndex}
                                                />
                                            </Box>
                                        </Grid>
                                    }
                                </>
                                    : <PageNotFoundUI title="Data not found" subtitle=" " />}
                            </Grid>}
                    </Box>
                </Paper>
                {/* <Loader isLoading={loading} /> */}
            </Box>
        </>

    )
}


export default CurriculumListContainer;
